import { render, staticRenderFns } from "./PagePart4.vue?vue&type=template&id=331685f3&scoped=true"
import script from "./PagePart4.vue?vue&type=script&lang=js"
export * from "./PagePart4.vue?vue&type=script&lang=js"
import style0 from "./PagePart4.vue?vue&type=style&index=0&id=331685f3&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "331685f3",
  null
  
)

export default component.exports